import React, { ReactElement } from 'react';
import { ContentRightStyled } from './contentRight.styled';
import { RightHeadContainer } from './rightHead';
import { useFormSubscriptionContext } from '../../../formSubscription.context';
import { SubscriptionButtonsContainer } from '../../../../../components';
import { useB2BFormSubscriptionContext } from '../../b2bFormSubscription.context';

export const ContentRightContainer = (): ReactElement => {
  const {
    course,
    isMobile,
    handleFormSubmit,
    isSubmitting,
    isSubscriptionFormContentSelected,
  } = useFormSubscriptionContext();
  const { subscriptionAvailability, isSubmitButtonDisabled } =
    useB2BFormSubscriptionContext();

  const isSubscriptionButtonDisabled =
    isSubscriptionFormContentSelected &&
    (isSubmitButtonDisabled || isSubmitting);

  const subscription = subscriptionAvailability
    ? {
        isCourseClaimed: subscriptionAvailability.isCourseClaimed,
        isClaimAvailable: subscriptionAvailability.isClaimAvailable,
        isClaimAvailableInNextPeriod:
          new Date(subscriptionAvailability.nextClaimPeriodStart) <
          new Date(subscriptionAvailability.subscriptionAccess.expiredAt),
        coursesClaimed: subscriptionAvailability.coursesClaimed,
        nextClaimPeriodStart: subscriptionAvailability.nextClaimPeriodStart,
        title: subscriptionAvailability.subscriptionAccess.subscription.title,
      }
    : null;

  return (
    <ContentRightStyled>
      <RightHeadContainer course={course} isMobile={isMobile} />
      <SubscriptionButtonsContainer
        subscription={subscription}
        handleSignUp={handleFormSubmit}
        isSignUpDisabled={isSubscriptionButtonDisabled}
      />
    </ContentRightStyled>
  );
};
